module.exports = __webpack_public_path__ + "img/gift5-07-c1.8efccb5e.png";